import React from 'react';
import SpeakerIcon from './diarization/SpeakerIcon.js';

/**
 * 音声を差し替えた後に、文字起こし・AI要約・AIフィードバックが前の音声（または貼り付けの本文）から作られたままである
 * ことの表示 (SCR-D-001 §6.2「音声を差し替えた後の内容」。#1952)。
 *
 * 判定はサーバの印 `ai_content_outdated`（面談の取得の応答）で行う。画面だけで覚えると、再読み込み・別の端末で失われるため。
 * 音声が無い面談では印をサーバが下ろすため、画面でも音声があるときだけ立っているとみなす（削除の後に面談を取り直さないため）
 */

// 3 つの文は DESIGN の案（#1952 comment 6580176745）。文を場所ごとに変えない（3 つのタブで同じ文）
export const AI_CONTENT_OUTDATED_NOTICE =
  'この内容は、現在の音声ファイルを登録する前に作成されたものです。現在の音声ファイルで作り直すには、「文字起こし」タブの「文字起こしを実行」を押してください。';
// 確認モーダル「AI処理の確認」に出す、上書きの文。作り直しと、差し替えの直後の両方に出す（丹羽様のご判断。#1952 comment 6569382996）
export const AI_CONTENT_OVERWRITE_NOTICE =
  '作成済みの文字起こし・AI要約・AIフィードバックは、作り直した内容に置き換わります。手で編集した内容も残らず、元に戻せません。';
// 印が立っている間に止める「AI要約を実行」「AIフィードバックを実行」の理由。単独で実行すると新旧の内容が混ざるため
export const AI_CONTENT_OUTDATED_DISABLED_REASON =
  '現在の音声ファイルで文字起こしを作り直すまで実行できません。「文字起こし」タブの「文字起こしを実行」から作り直してください。';

/** @param {{meetingData: object|null, audioAttachment: object|null}} params */
export function isAIContentOutdated({ meetingData, audioAttachment }) {
  return Boolean(meetingData?.ai_content_outdated) && Boolean(audioAttachment);
}

/** 差し替えの直後に開く確認モーダルで上書きの文を出すか。サーバが印を立てる条件（どれかが空でない）と同じ */
export function hasAnyAIContent(meetingData) {
  return Boolean(meetingData?.meeting_transcript || meetingData?.meeting_summary || meetingData?.ai_feedback);
}

/** 3 つのタブの本文の上に出す注記。既存の DP-D-009 のバナーと同じ形（新しいスタイルを足さない） */
export function AIContentOutdatedNotice() {
  return (
    <p className="diar-warning diar-warning--banner" data-testid="ai-content-outdated-notice">
      <SpeakerIcon name="triangle-alert" />
      <span>{AI_CONTENT_OUTDATED_NOTICE}</span>
    </p>
  );
}
